import {
  Type,
  Upload,
  ImageIcon,
  Film,
  Mic2,
  Edit2,
  AlignLeft,
  FileText,
  Scissors,
  Grid3x3,
  FolderTree,
  Clapperboard,
  FileStack,
  Layers,
} from 'lucide-react';
import { NodeType } from '../types';

export interface NodeTypeConfigEntry {
  color: string;
  border: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  name: string;
  bg?: string;
  label?: string;
}

export const NODE_TYPE_CONFIG: Record<NodeType, NodeTypeConfigEntry> = {
  [NodeType.PROMPT_INPUT]: { color: 'text-amber-400', border: 'border-amber-500/30', icon: Type, name: '创意描述', bg: 'bg-amber-500/10', label: '提示词' },
  [NodeType.MEDIA_UPLOAD]: { color: 'text-orange-400', border: 'border-orange-500/30', icon: Upload, name: '媒体上传', bg: 'bg-orange-500/10', label: '上传' },
  [NodeType.IMAGE_GENERATOR]: { color: 'text-cyan-400', border: 'border-cyan-500/30', icon: ImageIcon, name: '图片生成', bg: 'bg-cyan-500/10', label: '生图' },
  [NodeType.VIDEO_GENERATOR]: { color: 'text-purple-400', border: 'border-purple-500/30', icon: Film, name: '视频生成', bg: 'bg-purple-500/10', label: '生视频' },
  [NodeType.AUDIO_GENERATOR]: { color: 'text-pink-400', border: 'border-pink-500/30', icon: Mic2, name: '灵感音乐', bg: 'bg-pink-500/10', label: '生音频' },
  [NodeType.IMAGE_EDITOR]: { color: 'text-rose-400', border: 'border-rose-500/30', icon: Edit2, name: '图像编辑', bg: 'bg-rose-500/10', label: '编辑' },
  [NodeType.TEXT_NODE]: { color: 'text-amber-400', border: 'border-amber-500/30', icon: AlignLeft, name: '文本节点', bg: 'bg-amber-500/10', label: '备注' },
  [NodeType.SCRIPT_NODE]: { color: 'text-emerald-400', border: 'border-emerald-500/30', icon: FileText, name: '脚本生成器', bg: 'bg-emerald-500/10', label: '脚本' },
  // 智能剪辑：枚举值 VIDEO_COMPOSE 保持不变，用户可见名称统一为「智能剪辑」（方案 §2.1 命名决策）
  [NodeType.VIDEO_COMPOSE]: { color: 'text-slate-400', border: 'border-slate-500/30', icon: Scissors, name: '智能剪辑', bg: 'bg-slate-500/10', label: '剪辑' },
  [NodeType.PANORAMA_GENERATOR]: { color: 'text-teal-400', border: 'border-teal-500/30', icon: Grid3x3, name: '720°全景图', bg: 'bg-teal-500/10', label: '全景' },
  [NodeType.DIRECTOR]: { color: 'text-slate-300', border: 'border-slate-500/30', icon: Clapperboard, name: '导演台', bg: 'bg-slate-500/10', label: '导演台' },
  [NodeType.LAYER_EDIT]: { color: 'text-slate-300', border: 'border-slate-500/30', icon: Layers, name: '图层编辑', bg: 'bg-slate-500/10', label: '图层编辑' },
  [NodeType.DETAIL_PAGE]: { color: 'text-slate-200', border: 'border-slate-400/30', icon: FileStack, name: '详情页', bg: 'bg-slate-400/10', label: '详情页' },
  [NodeType.GROUP]: { color: 'text-slate-400', border: 'border-slate-500/30', icon: FolderTree, name: '分组', bg: 'bg-slate-500/10', label: '分组' },
};
